












import Vue from 'vue'
import Component from 'vue-class-component'
import { State, Getter, Action, Mutation } from 'vuex-class'

import DmoMenu from './menu.vue'
import SvgIcon from './SvgIcon'
import { mapState } from 'vuex'

@Component({
  components: { DmoMenu, SvgIcon }
})
export default class DmoHeader extends Vue {
  @Getter('title') title
  @Getter('projectUrl') projectUrl

  get titlep1() {
    return this.title.slice(0, this.title.length - 1)
  }

  get titlep2() {
    return this.title.charAt(this.title.length - 1)
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/header.vue